import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLE_HOME } from "../lib/api";

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center bg-[#FDFBF7]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#1F4A38] border-t-transparent" />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role] || "/"} replace />;
  return children;
}
